import numeral from 'numeral';
import BigNumber from 'bignumber.js';

const DECIMAL_PLACES = 10;
export default class NumberUtils {
	static isBlank(value) {
		return Number.isNaN(value) || (!value && value !== '0');
	}

	static isNotBlank(value) {
		return !this.isBlank(value);
	}

	static isNullSetZero(number) {
		if (!number) {
			return 0;
		}
		return number;
	}

	static decimalStep(decimal) {
		return '0.' + ('0'.padEnd(decimal - 1, '0') + 1);
	}

	static getLastDicimal(decimal) {
		return this.decimalStep(decimal);
	}

	static preciseRound(number, decimal) {
		const dicimal = new BigNumber(number);
		const result = dicimal.decimalPlaces(decimal, BigNumber.ROUND_HALF_UP);
		return this.filterResult(result);
	}

	static parseNumberToString(number, decimal) {
		if (number === undefined) return null;
		if (Number.isNaN(number)) return null;
		return this.formatNumber(number, decimal, false);
	}

	static parseStringToNumber(number) {
		return Number(number);
	}

	static formatNumber(number, decimal, isShowComma = true) {
		let formatDecimal;

		if (!Number.isNaN(decimal) && decimal >= 0) {
			if (isShowComma) {
				const bigNumber = new BigNumber(number);
				return bigNumber.toFormat(decimal);
			} else {
				const bigNumber = new BigNumber(number);

				const fmt = {
					decimalSeparator: '.',
					groupSeparator: '',
					groupSize: 3,
					secondaryGroupSize: 0,
				};
				return bigNumber.toFormat(decimal, fmt);
			}
		} else {
			if (isShowComma) {
				formatDecimal = '0,0';
			} else {
				formatDecimal = '0';
			}
			let str = `${numeral(number).format(formatDecimal)}`;
			const split = number.toString().split(/\./g);
			if (split.length > 1) {
				return `${str}.${split[1]}`;
			}
			return str;
		}
	}

	static add(num1, num2) {
		// const number1 = numeral(num1);
		// return number1.add(num2).value();
		const number1 = new BigNumber(num1);
		const number2 = new BigNumber(num2);
		return this.filterResult(number1.plus(number2));
	}

	static subtract(num1, num2) {
		// const number1 = numeral(num1);
		// return number1.subtract(num2).value();
		const number1 = new BigNumber(num1);
		const number2 = new BigNumber(num2);

		return this.filterResult(number1.minus(number2));
	}

	static multiply(num1, num2) {
		// const number1 = numeral(num1);
		// return number1.multiply(num2).value();
		const number1 = new BigNumber(num1);
		const number2 = new BigNumber(num2);
		return this.filterResult(number1.multipliedBy(number2));
	}

	static divide(num1, num2) {
		// const number1 = numeral(num1);
		// return number1.divide(num2).value();
		const number1 = new BigNumber(num1);
		const number2 = new BigNumber(num2);
		return this.filterResult(number1.dividedBy(number2));
	}

	static pow(num1, num2 = 0) {
		// let total = numeral(0);
		// const number1 = numeral(num1);

		// if (num2 === 0) {
		// 	total = numeral(1);
		// } else if (num2 === 1) {
		// 	total = number1.multiply(num2);
		// } else {
		// 	for (let i = 1; i < num2; i++) {
		// 		total = number1.multiply(num1);
		// 	}
		// }

		// return total.value();
		const number1 = new BigNumber(num1);
		const number2 = new BigNumber(num2);
		return this.filterResult(number1.pow(number2));
	}

	static filterResult(result) {
		if (result && !isNaN(result)) {
			return result.toString(DECIMAL_PLACES);
		}

		return null;
	}
}
